export default {
    user: {
        create: {
            title: "New user",
            model: {
                email: {
                    label: "Email",
                    placeholder: "Fill email"
                },
                name: {
                    label: "Name",
                    placeholder: "Fill name"
                },
                country: {
                    label: "Country",
                    placeholder: "Fill country"
                },
                approval_manager_email: {
                    label: "Manager email",
                    placeholder: "Fill manager email",
                    errors: {
                        different: "Approval manager email must be different from user email"
                    }
                }
            },
            cta: {
                submit: {
                    text: "Submit",
                    processing: "Submitting"
                },
                cancel: {
                    text: "Cancel"
                }
            }
        }
    }
}